import type { ListAuditLogResponse } from '@jq4race/shared';

import { request } from './client.js';

export async function getTicketHistory(ticketId: string): Promise<ListAuditLogResponse> {
  return request<ListAuditLogResponse>(`/admin/tickets/${encodeURIComponent(ticketId)}/history`, {
    method: 'GET',
  });
}
